import React from 'react';
import { Link } from 'react-router-dom';
import './footer.scss';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/privacy-policy" className="footer-link">
            Privacy Policy
          </Link>
          <Link to="/terms-and-conditions" className="footer-link">
            Terms & Conditions
          </Link>
        </div>
        <div className="footer-copyright">
          © {new Date().getFullYear()} Construction Admin. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer; 